import { ActivityLogs, ActivityLogsAction, ActivityLogsPayload } from "../interfaces/global-interfaces";

export default function activityLogsAction(logs: ActivityLogsPayload[]) {
    return {
        type: ActivityLogsAction.Update,
        payload: logs
    }  as ActivityLogs
}